import config from '../config';
import { customFetch, handleResponse, jsonHeader, commonRequestOptions } from '../helpers';

const endpointPath = config.api.API_URL + '/auth';

export const authenticationService = {
  login,
  logout,
  startLogin,
  endLogin,
  refreshAccessToken,
};

function startLogin(state, signal) {
  let requestOptions = {
    method: 'POST',
    headers: { ...jsonHeader() },
    body: JSON.stringify({ state }),
    ...commonRequestOptions(),
  };

  let endpoint = `${endpointPath}/login/start`;

  return customFetch(endpoint, requestOptions, signal).then(handleResponse);
}

function endLogin(url, signal) {
  let requestOptions = {
    method: 'POST',
    headers: { ...jsonHeader() },
    body: JSON.stringify({ url }),
    ...commonRequestOptions(),
  };

  let endpoint = `${endpointPath}/login/end`;

  return customFetch(endpoint, requestOptions, signal).then(handleResponse);
}

function refreshAccessToken(signal) {
  let requestOptions = {
    method: 'POST',
    headers: { ...jsonHeader() },
    ...commonRequestOptions(),
  };

  let endpoint = `${endpointPath}/refresh_access_token`;

  return customFetch(endpoint, requestOptions, signal).then(handleResponse);
}

function login(username, password, signal) {
  let requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
    ...commonRequestOptions(),
  };

  let endpoint = `${endpointPath}/login`;

  return customFetch(endpoint, requestOptions, signal).then(handleResponse);
}

function logout(signal) {
  let requestOptions = {
    method: 'POST',
    headers: { ...jsonHeader() },
    ...commonRequestOptions(),
  };

  let endpoint = `${endpointPath}/logout`;

  return customFetch(endpoint, requestOptions, signal).then(handleResponse);
}
